import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { api } from "@/lib/api";

const slug = (d) => d.replace(/\s+/g, "-");

export const DomainPicker = ({ onChange }) => {
  const [all, setAll] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    api.get("/domains").then((d) => {
      setAll(d.all);
      setSelected(d.selected);
    });
  }, []);

  const toggle = async (d) => {
    const next = selected.includes(d) ? selected.filter((x) => x !== d) : [...selected, d];
    setSelected(next);
    await api.put("/domains", { domains: next });
    onChange?.(next);
  };

  return (
    <div className="panel p-8" data-testid="domain-picker">
      <span className="overline">What are you exploring right now?</span>
      <p className="mt-4 text-sm text-muted-foreground leading-relaxed max-w-2xl">
        Pick as many as you like — change them anytime. Loop always slips in a couple of wildcards
        from outside your focus areas. Leave it empty to explore everything.
      </p>
      <div className="mt-6 flex flex-wrap gap-2">
        {all.map((d) => {
          const on = selected.includes(d);
          return (
            <button
              key={d}
              onClick={() => toggle(d)}
              data-testid={`domain-${slug(d)}`}
              aria-pressed={on}
              className={`flex items-center gap-2 text-sm px-4 py-2 rounded-full border transition-colors duration-200 ${
                on
                  ? "border-primary/60 bg-primary/10 text-primary"
                  : "border-white/10 text-muted-foreground hover:text-white hover:bg-white/[0.06]"
              }`}
            >
              {on && <Check className="h-3.5 w-3.5" />}
              {d}
            </button>
          );
        })}
      </div>
    </div>
  );
};
